import { render } from "./OfficialTotal.vue?vue&type=template&id=5334e794&scoped=true"
import script from "./OfficialTotal.vue?vue&type=script&lang=js"
export * from "./OfficialTotal.vue?vue&type=script&lang=js"

import "./OfficialTotal.vue?vue&type=style&index=0&id=5334e794&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5334e794"

export default script